import React from 'react';
import { SparkIcon, Text } from '@spark';

const SECTIONS = [
    {
        title: 'Content & Data Management',
        rows: [
            { name: 'View', description: 'View all projects, tasks, and data', admin: true, editor: true, viewer: true },
            { name: 'Create', description: 'Create new projects, tasks and data entries', admin: true, editor: true, viewer: false },
            { name: 'Edit', description: 'Modify existing projects, tasks, and data', admin: true, editor: true, viewer: false },
            { name: 'Annotate', description: 'Annotate existing data records', admin: true, editor: true, viewer: true },
            { name: 'Delete', description: 'Permanently delete reports, dashboards, or data', admin: true, editor: true, viewer: false },
            { name: 'Export', description: 'Export data or models', admin: true, editor: true, viewer: false },
        ],
    },
    {
        title: 'User & Role Management',
        rows: [
            { name: 'View', description: 'View the list of all users and their roles', admin: true, editor: false, viewer: false },
            { name: 'Approve', description: 'Approve new users to the system', admin: true, editor: false, viewer: false },
            { name: 'Edit', description: 'Modify user details (e.g., name, email)', admin: true, editor: false, viewer: false },
            { name: 'Delete', description: 'Deactivate or delete user accounts', admin: true, editor: false, viewer: false },
            { name: 'Assign', description: 'Assign roles to other users', admin: true, editor: false, viewer: false },
        ],
    },
    {
        title: 'Organization Settings',
        rows: [
            { name: 'View settings', description: 'View organization-level preferences', admin: true, editor: false, viewer: false },
            { name: 'Edit settings', description: 'Change organization-level preferences', admin: true, editor: false, viewer: false },
        ],
    },
];

function PermissionMark({ allowed }) {
    return (
        <span
            className={
                allowed
                    ? 'settings-roles-matrix__mark settings-roles-matrix__mark--allowed'
                    : 'settings-roles-matrix__mark settings-roles-matrix__mark--denied'
            }
            aria-label={allowed ? 'Allowed' : 'Not allowed'}
        >
            <SparkIcon slug={allowed ? 'circle-check' : 'circle-x'} size="medium" />
        </span>
    );
}

export default function RolesPermissionsMatrix() {
    return (
        <div className="settings-roles-matrix" role="table">
            <div className="settings-roles-matrix__header" role="row">
                <Text as="div" variant="uniq-semibold-table-caps" color="primary" className="settings-roles-matrix__header-cell">
                    Permission
                </Text>
                <Text as="div" variant="uniq-semibold-table-caps" color="primary" className="settings-roles-matrix__header-cell settings-roles-matrix__header-cell--center">
                    Admin
                </Text>
                <Text as="div" variant="uniq-semibold-table-caps" color="primary" className="settings-roles-matrix__header-cell settings-roles-matrix__header-cell--center">
                    Editor
                </Text>
                <Text as="div" variant="uniq-semibold-table-caps" color="primary" className="settings-roles-matrix__header-cell settings-roles-matrix__header-cell--center">
                    Viewer
                </Text>
            </div>
            {SECTIONS.map((section) => (
                <React.Fragment key={section.title}>
                    <div className="settings-roles-matrix__section" role="row">
                        <Text as="div" variant="base-semibold" color="primary">{section.title}</Text>
                    </div>
                    {section.rows.map((row) => (
                        <div className="settings-roles-matrix__row" role="row" key={`${section.title}-${row.name}`}>
                            <div className="settings-roles-matrix__cell">
                                <Text as="div" variant="base-semibold" color="primary">{row.name}</Text>
                                <Text as="div" variant="detail-regular" color="tertiary">{row.description}</Text>
                            </div>
                            <div className="settings-roles-matrix__cell settings-roles-matrix__cell--center">
                                <PermissionMark allowed={row.admin} />
                            </div>
                            <div className="settings-roles-matrix__cell settings-roles-matrix__cell--center">
                                <PermissionMark allowed={row.editor} />
                            </div>
                            <div className="settings-roles-matrix__cell settings-roles-matrix__cell--center">
                                <PermissionMark allowed={row.viewer} />
                            </div>
                        </div>
                    ))}
                </React.Fragment>
            ))}
        </div>
    );
}
